import { authenticatedPost, authenticatedGet } from "../../../Services/core";

export const TenantsList = async (request) => {
   return await authenticatedPost(request, process.env.REACT_APP_BASE_URL+'tenants/list');
}
